import WalletState from "@/models/Accounts/DepositAccounts/Wallets/WalletState";

export default (val: WalletState) => {
    let returnVal = "Undefined";
    switch (val) {
        case WalletState.Active:
            returnVal = "Active"
            break;
        case WalletState.Closed:
            returnVal = "Closed"
            break;
    }
    return returnVal;
}